import * as types from './mutation-types';

import Vue from 'vue';

export default {
  success({ commit }, payload) {
    Vue.prototype.$vs.notification({ color: 'success', title: 'Success', text: payload });
    commit(types.ADD, payload);
  },
  error({ commit }, payload) {
    Vue.prototype.$vs.notification({ color: 'danger', title: 'Error', text: payload });
    commit(types.ADD, payload);
  },
};
